module.exports = __webpack_public_path__ + "img/Empresa.2ea3f07d.png";